exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog[data-v-49dce350]{overflow-y:visible!important}", ""]);

// exports
